export default "__VITE_ASSET__8yDLk3Lq__"